<template>
  <div>
    <LoginHome v-if="!tokenErrorType" @on-login="value => login(value)"/>

    <LoginError
      v-else
      :img-src="error!.imgSrc"
      :title="error!.title"
      :description="error!.description"
      @go-back="tokenErrorType = null"
    />
  </div>
</template>

<script setup lang="ts">
import type { OperatorLoginResponse } from '@/services/WarrantyApiService/types';
import { useUserStore } from '@/stores/user.store';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import LoginError from "./LoginError.vue";
import LoginHome from "./LoginHome.vue";
import { loginOperator } from './query';
import { backendErrorToLoginErrorScreenMap, LoginErrorScreenEnum, loginErrorScreenMap } from './util';

const router = useRouter();

const userStore = useUserStore();

const tokenErrorType = ref<LoginErrorScreenEnum | null>(null);
const error = computed(() => tokenErrorType.value ? loginErrorScreenMap[tokenErrorType.value] : null);

async function login(accessKey: string) {
  try {
    const response = await loginOperator(accessKey) as OperatorLoginResponse;
    userStore.actions.setToken(response.jwtToken);
    router.push({ name: 'home' });
  }
  catch(e: any) {
    tokenErrorType.value = backendErrorToLoginErrorScreenMap[e.message];
  }
}
</script>